import { STORAGE_KEYS } from '@sh4res/bo-common/utils/storage_keys';

let deviceId: string | undefined;

export function getDeviceId(): string {
  return deviceId ?? resetDeviceId();
}

function resetDeviceId(): string {
  deviceId = window.localStorage.getItem(STORAGE_KEYS.deviceId) ?? '';

  if (!deviceId) {
    deviceId = crypto.randomUUID();

    window.localStorage.setItem(STORAGE_KEYS.deviceId, deviceId);
  }

  return deviceId;
}
